import { FootballField, viewWindow, clampPoint, CENTER_X } from "@/sports/football";

// Sport registry: field layout + geometry. Playbook, editor, playback and sharing are shared.
export const SPORTS = {
  football: { key: "football", name: "Football", Field: FootballField, viewWindow, clampPoint, centerX: CENTER_X },
};

export const getSport = (key) => SPORTS[key] || SPORTS.football;
